let language = {
    SELECT_STORE_TITLE:"Select store",
    SELECT_STORE_CREATE_STORE_TIP:"go to creat store",

};

export { language }